
import axios from "axios";
import { refreshSessionOrLogout } from "./interceptors";
import { commonHeaders } from "./commonHeader";
import TokenService from "./tokenManager";
import { toast } from "react-toastify";
import { logOutUser } from "store/api/auth";
import { API_BASE_URL_ACCOUNT } from "config";

// Setup Axios instance
const authClient = axios.create({
  // baseURL: "https://digitallending.accessbankplc.com:9092",
  baseURL:API_BASE_URL_ACCOUNT,

  headers: commonHeaders,
});

// Manage idle timeout
let idleTimeout: number | null = null;
const idleTimeoutLimit = 5 * 60 * 1000; // 5 minutes

const resetIdleTimeout = () => {
  if (idleTimeout) {
    clearTimeout(idleTimeout);
  }

  if (TokenService.getLocalAccessToken()) {
    idleTimeout = window.setTimeout(() => {
      handleIdleLogout();
    }, idleTimeoutLimit);
  }
}
  
const handleIdleLogout = async () => {
  if (!TokenService.getLocalAccessToken()) {
    // Prevent calling logout if the user is already logged out
    return;
  }
  try {
    const response = await logOutUser();
    if (response?.data?.Status === 200) {
      TokenService.removeUser();
      toast.info("You have been logged out due to inactivity.");
      window.location.href = '/login';

    } else {
      toast.error(response?.data?.Message);
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.Message || error?.message);
    return error.response;
  }
}

// Redirect to login page



const events = ['mousemove', 'keydown', 'mousedown', 'touchstart'];
events.forEach((event) => {
  window.addEventListener(event, resetIdleTimeout);
});

if (TokenService.getLocalAccessToken()) {
  resetIdleTimeout();
}
// Request interceptor
authClient.interceptors.request.use(
  (config) => {
    const token = TokenService.getLocalAccessToken();
    if (token && config.headers) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Combined Response interceptor with both error handling and session refresh
authClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Check for network error
    if (!error.response) {
      // toast.error('An error just occurred. Please try again later.');
    } else {
      // toast.error('We\'re sorry, this service is currently not available. Please try again later.');
    }
    return Promise.reject(error);
  }
);

// Use session refresh or logout logic
authClient.interceptors.response.use(
  (res) => {
    return res;
  },
  refreshSessionOrLogout()
);

export default authClient;



